export const environment = {
  production: true,
  apiUrl: 'https://api.jafy.co',
  appName: 'Jafy',
  version: '1.0.0',
  enableLogging: false,
  debugMode: false,
};
